import { Component, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';
import { OrganizationConfigService } from '../../../../../../../services/organization-config/organization-config.service';


@Component({
  selector: 'app-add-mx-merchant-connection-modal',
  templateUrl: './add-mx-merchant-connection-modal.component.html',
  styleUrls: ['./add-mx-merchant-connection-modal.component.css']
})
export class AddMxMerchantConnectionModalComponent {
  @Input() savedCallback: (result: CallbackResult) => void;

  public connectionName = 'MX Merchant';
  public merchantId = '';
  public consumerApiKey = '';
  public consumerApiSecret = '';

  public loadingSave = false;

  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private orgConfigService: OrganizationConfigService,
  ) {}

  public allInputsValid() {
    return (
      (this.connectionName !== '') &&
      (this.merchantId !== '') &&
      (this.consumerApiKey !== '') &&
      (this.consumerApiSecret !== '')
    )
  }

  public handleSubmit() {
    if (!this.allInputsValid()) { return; }

    this.loadingSave = true;
    this.errorMessage = '';

    this.orgConfigService
      .setUpMXMerchantPaymentProcessorConnection(
        this.connectionName,
        this.merchantId,
        this.consumerApiKey,
        this.consumerApiSecret
      )
      .then(conn => {
        this.savedCallback({
          text: 'MX Merchant connection added successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.stattus === 403) {
          this.errorMessage = 'You do not have permission to add this connection.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSave = false; });
  }
}
